import { useEffect } from 'react'
import { useUiStore } from '@/store/ui'
import { useEntity } from '@/store/hooks'

/**
 * Apply the theme to <html data-theme>. 'auto' follows sun.sun (below_horizon →
 * dark). Default root is dark, so we only set data-theme=light when needed.
 */
export function useThemeEffect(): void {
  const theme = useUiStore((s) => s.theme)
  const sun = useEntity('sun.sun')

  useEffect(() => {
    const root = document.documentElement
    let resolved: 'dark' | 'light'
    if (theme === 'auto') {
      resolved = sun?.state === 'above_horizon' ? 'light' : 'dark'
    } else {
      resolved = theme
    }
    root.setAttribute('data-theme', resolved)
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.setAttribute('content', resolved === 'light' ? '#f3f4f8' : '#0b0e13')
  }, [theme, sun?.state])
}
